function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.36 11.694c-4.44 0-8.038-3.5-8.038-7.813 0-1.42.42-2.734 1.102-3.881C2.72 1.037 0 4.316 0 8.247c0 4.76 3.97 8.62 8.869 8.62 4.043 0 7.42-2.647 8.486-6.243-1.182.661-2.533 1.07-3.995 1.07z"
});

var SvgNight = function SvgNight(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 17"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE4IDE3Ij4KICA8cGF0aCBkPSJNMTA1Ny4zNTk5MSwxMzQ1LjY5MzUgQzEwNTIuOTE5MDgsMTM0NS42OTM1IDEwNDkuMzIyMTYsMTM0Mi4xOTQ4OSAxMDQ5LjMyMjE2LDEzMzcuODgxMzIgQzEwNDkuMzIyMTYsMTMzNi40NjA2OCAxMDQ5Ljc0MTQxLDEzMzUuMTQ2NTIgMTA1MC40MjM2OSwxMzM0IEMxMDQ2LjcyMDQ3LDEzMzUuMDM3NDEgMTA0NCwxMzM4LjMxNTY4IDEwNDQsMTM0Mi4yNDY1NSBDMTA0NCwxMzQ3LjAwNzEzIDEwNDcuOTcwMDYsMTM1MC44Njc4OSAxMDUyLjg2ODY0LDEzNTAuODY3ODkgQzEwNTYuOTEyNDcsMTM1MC44Njc4OSAxMDYwLjI4ODExLDEzNDguMjIwMDcgMTA2MS4zNTU0NywxMzQ0LjYyNDQ2IEMxMDYwLjE3MzEzLDEzNDUuMjg1NDkgMTA1OC44MjE1NywxMzQ1LjY5MzUgMTA1Ny4zNTk5MSwxMzQ1LjY5MzUgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNDQgLTEzMzQpIi8+Cjwvc3ZnPgo=";
export { SvgNight as ReactComponent };